import queryString from "query-string";
import {
  CREATE_ACCOUNT,
  DELETE_ACCOUNT,
  GET_ACCOUNT_LIST,
  UPDATE_ACCOUNT,
  GET_LIST_BOX_OPEX_REALIZATION,
  GET_LIST_BOX_OPEX_MONITORING,
  GET_LIST_BOX_CAPEX_REALIZATION,
  GET_LIST_BOX_CAPEX_MONITORING
} from "@/api/masterData/tt-account";

const state = {
  list_account: [],
  list_box_opex_realization: [],
  list_box_opex_monitoring: [],
  list_box_capex_realization: [],
  list_box_capex_monitoring: [],
  mode: "",
};

const mutations = {
  SET_LIST_ACCOUNT: (states, payload) => {
    states.list_account = payload;
  },
  SET_LIST_BOX_OPEX_REALIZATION: (states, payload) => {
    states.list_box_opex_realization = payload;
  },
  SET_LIST_BOX_OPEX_MONITORING: (states, payload) => {
    states.list_box_opex_monitoring = payload;
  },
  SET_LIST_BOX_CAPEX_REALIZATION: (states, payload) => {
    states.list_box_capex_realization = payload;
  },
  SET_LIST_BOX_CAPEX_MONITORING: (states, payload) => {
    states.list_box_capex_monitoring = payload;
  },
  SET_MODE: (states, payload) => {
    states.mode = payload;
  },
};

const actions = {
  GET_LIST_ACCOUNT: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_ACCOUNT_LIST(query);
    const data = resp.data.data;
    commit("SET_LIST_ACCOUNT", data);
  },
  GET_LIST_BOX_OPEX_REALIZATION: async ({ commit }, { planId, fundCenterId }) => {
    //query = queryString.stringify(query);
    const resp = await GET_LIST_BOX_OPEX_REALIZATION(planId, fundCenterId);
    const data = resp.data.data;
    commit("SET_LIST_BOX_OPEX_REALIZATION", data);
  },
  GET_LIST_BOX_OPEX_MONITORING: async ({ commit }, { planId, fundCenterId }) => {
    //query = queryString.stringify(query);
    const resp = await GET_LIST_BOX_OPEX_MONITORING(planId, fundCenterId);
    const data = resp.data.data;
    commit("SET_LIST_BOX_OPEX_MONITORING", data);
  },
  GET_LIST_BOX_CAPEX_REALIZATION: async ({ commit }, { planId, fundCenterId }) => {
    //query = queryString.stringify(query);
    const resp = await GET_LIST_BOX_CAPEX_REALIZATION(planId, fundCenterId);
    const data = resp.data.data;
    commit("SET_LIST_BOX_CAPEX_REALIZATION", data);
  },
  GET_LIST_BOX_CAPEX_MONITORING: async ({ commit }, { planId, fundCenterId }) => {
    //query = queryString.stringify(query);
    const resp = await GET_LIST_BOX_CAPEX_MONITORING(planId, fundCenterId);
    const data = resp.data.data;
    commit("SET_LIST_BOX_CAPEX_MONITORING", data);
  },
  CREATE_ACCOUNT: ({}, payload) => {
    return CREATE_ACCOUNT(payload);
  },
  DELETE_ACCOUNT: ({}, payload) => {
    return DELETE_ACCOUNT(payload);
  },
  UPDATE_ACCOUNT: ({}, payload) => {
    return UPDATE_ACCOUNT(payload);
  },
};

const getters = {
  listAccount: (states) => states.list_account,
  list_box_opex_realization: (states) => states.list_box_opex_realization,
  list_box_opex_monitoring: (states) => states.list_box_opex_monitoring,
  list_box_capex_realization: (states) => states.list_box_capex_realization,
  list_box_capex_monitoring: (states) => states.list_box_capex_monitoring,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
